<template>
	<div id="centreLeft">
		<dv-border-box-6>
			<div class="pt-2 pl-2" style="position: absolute;left: 0;top: 0;">
				<div class="d-flex jc-between" style="width: 5rem;">
					<span class="pt-3 pl-3 title_t">客户展示</span>
					<span class="pt-3 pr-3">
						<el-button icon="el-icon-refresh" @click="showType=!showType" circle size='mini'></el-button>
					</span>
				</div>
			</div>
			<!-- <div class="pt-4 body-box">
				<el-carousel height="5rem">
					<el-carousel-item v-for="item of list_img" :key="item.index">
						<h3 class="small">
							<img class="img" :src="item.url" alt />
						</h3>
					</el-carousel-item>
				</el-carousel>
			</div> -->

			<div class="d-flex jc-center list-box" v-if="showType">
				<dv-scroll-board :config="config" style="width: 4.4rem; height: 4.4rem;margin: 0.8rem auto 0 auto" />
			</div>
			<!-- <div class="d-flex jc-around body-box" >
				<div class="img"></div>
			</div> -->
			<!-- <div class="body-box">
				<div style="margin-top: 1.3rem;">
					<el-carousel :interval="4000" type="card" height="1.25rem">
						<el-carousel-item v-for="item in list_img" :key="item.index">
							<div class="blackBox" style="display: flex;justify-content: center;align-items: center;">
								<img style="max-width: 1.5rem;max-height: 0.75rem;display: block;margin:0 auto;" :src="item.url" alt />
							</div>
						</el-carousel-item>
					</el-carousel>
				</div>
			</div> -->
			<div class="body-box" v-else>
				<div class="top_box d-flex jc-around" style="margin-top: 1.1rem;">
					<div class="blackBox d-flex jc-center">
						<el-carousel :interval="2000" style="margin-left: 0.12rem;margin-top: 0.22rem;" height="1.25rem">
						  <el-carousel-item v-for="item in list_img1" :key="item.index">
							<img :src="item.url" alt />
						  </el-carousel-item>
						</el-carousel>
					</div>
					<div class="blackBox d-flex jc-center">
						<el-carousel :interval="2100" height="1.25rem" style="margin-left: 0.12rem;margin-top: 0.22rem;">
						  <el-carousel-item v-for="item in list_img2" :key="item.index">
							<img :src="item.url" alt />
						  </el-carousel-item>
						</el-carousel>
					</div>
				</div>
				<div class="bottom_box d-flex jc-around" style="margin-top: -0.5rem;">
					<div class="blackBox d-flex jc-center">
						<el-carousel :interval="2200" style="margin-left: 0.12rem;margin-top: 0.22rem;" height="1.25rem">
						  <el-carousel-item v-for="item in list_img3" :key="item.index">
							<img :src="item.url" alt />
						  </el-carousel-item>
						</el-carousel>
					</div>
				</div>
			</div>
		</dv-border-box-6>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				config: {
					header: ["排名", "仓库名称", "面积m²"],
					data: [],
					rowNum: 8, //表格行数
					headerHeight: 24,
					headerBGC: "#085E7D", //表头
					oddRowBGC: "#0f1325", //奇数行
					evenRowBGC: "#171c33", //偶数行
					index: false,
					// columnWidth: [120],
					carousel: 'page',
					align: ["center", "center", "center"],
				},
				showType: false,
				list_img1: [{
						url: require('@/assets/luyan.png')
					},
					{
						url: require('@/assets/nanjing.png')
					},
					{
						url: require('@/assets/yingte.png')
					},
					{
						url: require('@/assets/zhejiang.png')
					}
				],
				list_img2: [
					{
						url: require('@/assets/dashenlin.png')
					},
					{
						url: require('@/assets/gaoji.png')
					},
					{
						url: require('@/assets/guangyao.png')
					},
					{
						url: require('@/assets/guoyao.png')
					}
				],
				list_img3: [
					{
						url: require('@/assets/shanghai.png')
					},
					{
						url: require('@/assets/kangenbei.png')
					},
					{
						url: require('@/assets/huadong.png')
					},
					{
						url: require('@/assets/jingxin.png')
					}
				],
			};
		},
		props: ['buildingShow'],
		watch: {
			'buildingShow': {
				handler() {
					this.init()
				},
				deep: true
			}
		},
		mounted() {

		},
		methods: {
			init() {
				this.config = {
					header: ["排名", "仓库名称", "面积m²"],
					data: this.buildingShow,
					rowNum: 8, //表格行数
					headerHeight: 24,
					headerBGC: "#085E7D", //表头
					oddRowBGC: "#0f1325", //奇数行
					evenRowBGC: "#171c33", //偶数行
					index: false,
					// columnWidth: [120],
					carousel: 'page',
					align: ["center", "center", "center"],
				}


			}
		},
	};
</script>

<style lang="scss">
	#centreLeft {
		height: 5.6375rem;
		width: 5.125rem;
		position: relative;
		
		.list-box{
			width: 4.925rem;
			height: 4.8rem;
		}

		.body-box {
			position: absolute;
			left: 0.1rem;
			top: 0.5rem;
			width: 4.925rem;
			height: 4.8rem;
			background: url("~@/assets/kehubg.png") no-repeat 100% 100%;
			background-size: cover;

			div {
				width: 5rem;
				height: 1.5rem;
				
				.blackBox{
					width: 1.75rem;
					height: 1.25rem;
					// marigi: 0 auto;
					background: url("~@/assets/khbj.png") no-repeat 100% 100%;
					background-size: cover;
					
					img{
						// background-color: #fff;
						// width: 1.5rem;
						// height: 0.75rem
					}
				}
			}

			.is-active {
				// margin-top: 1rem;
			}

			// .small {
			// 	width: 5.125rem;

			// 	.img {
			// 		height: 5rem;
			// 		width: 4.6rem;
			// 		margin: 0.6rem 0.25rem;
			// 		// background: url("~@/assets/zhanshi.png") no-repeat 100% 100%;
			// 		background-size: cover;
			// 	}
			// }

		}

		.el-carousel__item div {
			// line-height: 1rem;
			// color: #475669;
			// font-size: 14px;
			// opacity: 0.75;
			// margin: 0 auto;
			// background: url("~@/assets/guoyao.png") no-repeat 0 0;
			// background-size: cover;
			// img{
			// 	margin: 0 auto;
			// }
		}
		
		.el-carousel__indicators{
			display: none;
		}
		// .el-carousel__indicators .el-carousel__indicator--horizontal .el-carousel__button{
		// 	display: none;
		// }
		
		.el-carousel__item {
			// background-color: #fff;
			.el-carousel__mask{
				background: 0;
			}
			
			// display: flex;
			// justify-content: center;
		}

		.el-carousel__item:nth-child(2n) {
			// background-color: #99a9bf;
		}
		
		.el-carousel__arrow--left,.el-carousel__arrow--right{
			display: none;
		}

		.el-carousel__item:nth-child(2n+1) {
			// background-color: #d3dce6;
		}
	}
</style>
